import { Component, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  readonly #meta = inject(Meta);
  private translateService = inject(TranslateService);

  constructor() {
    const bodyStyles = window.getComputedStyle(document.body);
    const bgColor = bodyStyles.getPropertyValue('--background-color');
    this.#meta.addTag({ name: 'theme-color', content: bgColor });
    this.#meta.addTag({
      name: 'theme-color',
      content: bgColor,
      media: '(prefers-color-scheme: light)',
    });
    this.#meta.addTag({
      name: 'theme-color',
      content: bgColor,
      media: '(prefers-color-scheme: dark)',
    });
  }
}
